<div class="container-xl" [appStoryblok]="_editable">
  <div class="row">
    <div class="col-lg-3">
      <h1 class="display-1 mt-3">{{ title }}</h1>
      <div class="menu" *ngFor="let child of menu">
        <ndc-dynamic
          *ngIf="components"
          [ndcDynamicComponent]="components[child.content.component]"
          [ndcDynamicInputs]="child.content"
        >
        </ndc-dynamic>
      </div>
    </div>
    <div class="col-lg-8 offset-lg-1">
      <ng-container *ngFor="let blok of content">
        <ng-container *ngIf="blok.component === 'accordion-group'">
          <div class="py-4">
            <h4>{{ blok.title }}</h4>
          </div>
          <div
            *ngFor="let blok of blok.accordions; let last = last"
            [ngClass]="{ 'border-bottom': last }"
          >
            <ndc-dynamic
              *ngIf="components"
              [ndcDynamicComponent]="components[blok.component]"
              [ndcDynamicInputs]="blok"
            >
            </ndc-dynamic>
          </div>
        </ng-container>
        <div *ngIf="blok.component !== 'accordion-group'">
          <ndc-dynamic
            *ngIf="components"
            [ndcDynamicComponent]="components[blok.component]"
            [ndcDynamicInputs]="blok"
          >
          </ndc-dynamic>
        </div>
      </ng-container>
    </div>
  </div>
</div>
